import { t } from 'i18next';
import { z } from 'zod';
import { OnboardingFormFields } from '@Types/index';

export const otherFormSchema = z.object({
  [OnboardingFormFields.ACCOUNT_OPENING_REASON]: z
    .string()
    .min(0)
    .max(150, t('enErrors:accountOpeningReason.max')),
});

export type OtherFormSchema = z.infer<typeof otherFormSchema>;
